// The media server writes several renders of every picture next to the
// original, as "<path>/<size>-<name>.webp". A stored value usually points at
// the original — which is the right thing for the page itself and completely
// wrong for a 40px thumbnail in a list: those were pulling 3000px, multi-
// megabyte files, one per slide, and that is what made the slide panels and
// the block editor crawl.
//
// The smallest render every image type gets is 262 (products) or 360
// (everything else), so 360 is asked for and 262 is the fallback. If neither
// exists the caller falls back to the original, and nothing is ever broken.

const SIZED_NAME = /^\d+-/;

// Returns a small render of the same picture, or the value unchanged when it
// is not a media-server path (an absolute URL, a data: URI, an unknown shape).
export function smallVariant(path, size = 360) {
  if (typeof path !== "string" || path.length === 0) {
    return path;
  }
  const match = /^(.*)\/([^/]+)\.(webp|png|jpe?g|avif)$/i.exec(path);
  if (!match) {
    return path;
  }
  const [, dir, name, ext] = match;
  if (SIZED_NAME.test(name)) {
    return path;
  }
  return `${dir}/${size}-${name}.${ext}`;
}

// True when `candidate` is a small render this module produced from `original`.
export function isSmallVariantOf(candidate, original) {
  return (
    typeof candidate === "string" &&
    typeof original === "string" &&
    candidate !== original &&
    candidate.startsWith(original.slice(0, original.lastIndexOf("/") + 1))
  );
}
